<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="90"
      round
      :needBtnLoading="true"
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
    </GlobalForm>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Form",
  data() {
    const validateDateRange = (rule, value, callback) => {
      if (value && value.length === 2) {
        const start = moment(value[0]);
        const end = moment(value[1]);
        const diff = end.diff(start, "days");
        if (diff > 31) {
          callback(new Error("最多可查询31天"));
          return;
        }
      }
      callback();
    };
    return {
      initData: {
        selectTime: [
          moment().subtract(30, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      },
       pickerMinDate: null,
      pickerMaxDate: null,
      day31: 30 * 24 * 3600 * 1000,
      formItemList: [
        {
          key: "orderNo",
          type: "input",
          labelName: "订单编号",
          placeholder: "请输入订单编号",
        },
        {
          key: "transferNo",
          type: "input",
          labelName: "出账单号",
          placeholder: "请输入出账单号",
        },
        {
          key: "selectTime",
          type: "pickerOptions",
          labelName: "选择时间",
          placeholder: "请选择时间",
          valueFormat: "yyyy-MM-dd",
          clearable: true,
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                  time.getTime() > this.pickerMinDate + this.day31 ||
                  time.getTime() < this.pickerMinDate - this.day31
                );
              }
              return false;
            },
          },
        },
      ],
      formRules: {
        selectTime: [{ validator: validateDateRange, trigger: "change" }],
      },
      minDate: null,
    };
  },
  created() {
    this.handleConfirm(this.initData);
  },
  methods: {
    handleConfirm(data, cd) {
      let SeachParams = {};
      if (data) {
        SeachParams = {
          orderNo: data.orderNo,
          transferNo: data.transferNo,
          resetTimeFrom: data.selectTime ? moment(data.selectTime[0]).startOf("day").valueOf() : "",
          resetTimeTo: data.selectTime ? moment(data.selectTime[1]).endOf("day").valueOf() : "",
          pageNum: 1,
          pageSize: 50,
        };
      }
      SeachParams.disuseLoding = () => {
        if (typeof cd === "function") {
          cd();
        }
      };
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
}
</style>
